import SweetAlert from 'react-bootstrap-sweetalert';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import CountUp from 'react-countup';
import ViewMap from './ViewMap';
import DrawMap from '../common/drawmap';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { fetchGridLayout, getDecoder, getHyphenDDMMMYYYYHHMM, saveGridLayout } from '../common/utils';
import redirectURL from "../redirectURL";
import moment from "moment";
import ForceClose from './forceClose.jsx';
import DatePicker from 'react-datepicker'
import { Modal } from 'react-bootstrap';
import CommentModal from './commentModal.js';
import ModelForceClose from './modelForceClose.js';
import Info from '../../assets/icons/info.png'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import BulkForceClose from '../mainpage/bulkForceClose.js';

const ETAPastConsignments = () => {

    const user = useMemo(() => getDecoder(), []);
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [allData, setAllData] = useState([])
    const [rowData, setRowData] = useState([])
    const [tranistDelay, setTranistDelay] = useState([])
    const [hotLoads, setHotLoads] = useState([])
    const [deviatedRoutes, setDeviatedRoutes] = useState([])
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [overly, setOverlay] = useState("show-n")
    const [loadshow, setLoadShow] = useState("show-n")
    const [commentModal, setCommentModal] = useState(false);
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [rownode, setRownode] = useState([]);
    const [header, setHeader] = useState('Total FO Deliveries');
    const [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        consignment_code: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const gridColumnState = useRef(null)
    const columnApi = useRef(null)
    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            autoSizeColumns: true,
            resizable: true,
            pivot: true,
        }
    }, []);

    const columnDefs3 = useMemo(() => {
        return [
            {
                headerName: "",
                field: "",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: ViewMap,
                                params: {
                                    onClickShowRoute: onClickShowRouteLegs
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "comment_logs",
                pinned: "left",
                filter: false,
                suppressMenu: true,
                width: 50,
                cellRenderer: (param) => {
                    return (
                        (param.data.comment_logs == undefined || param.data.comment_logs == 0 || param.data.comment_logs == null || param.data.comment_logs == '') ?
                            < i className="fa fa-comments f20" title='Comment' style={{ color: "#cccc" }}></i > :
                            < i className="fa fa-comments txt-info f20" title='Comment' ></i >
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "tansit_delay_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-clock-time f20" title='Transit Delay' style={{ color: (param?.data?.transit_delay != undefined && param?.data?.transit_delay == 1) ? "#FF5370" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "deviation_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="fa fa-random f20" title='Deviated Routes' style={{ color: (param?.data?.deviation_identified != undefined && param?.data?.deviation_identified == 1) ? "#9f08b2" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "FO Number",
                field: "fo_number",
                width: 118,
            },
            {
                headerName: "Vehicle No.",
                field: "truck_no",
                width: 122,
            },
            {
                headerName: "Customer Code",
                field: "consignee_code"
            },
            {
                headerName: "Status",
                field: "status",
                width: 148,
                valueGetter: function (params) {
                    if (params.data.status == 1) {
                        if (params.data.gate_in_time == undefined || params.data.gate_in_time == null || params.data.gate_in_time == "")
                            return "Consignment Created"
                        else
                            return "Inside Plant";
                    }
                    else if (params.data.status == 2) {
                        return "In Transit";
                    }
                    else if (params.data.status == 3) {
                        return "Near Customer";
                    }
                    else if (params.data.status == 4) {
                        return "Reached Customer";
                    }
                    else if (params.data.status == 5) {
                        return "Left Customer";
                    }
                    else if (params.data.status == 6) {
                        return "Force Closed";
                    }
                    else if (params.data.status == 7) {
                        return "Proximity Trip Closure";
                    }
                    else if (params.data.status == 8) {
                        return "Cancelled";
                    }
                    else if (params.data.status == 9) {
                        return "Trip Closed";
                    }
                    else {
                        return "N/A";
                    }
                }
            },
            {
                headerName: "SIM Consent Status",
                field: "sim_tracking_state",
                width: 188,
                valueGetter: function (params) {
                    try {
                        if (params.data.tracking_mode == "GPS")
                            return "Approved"
                        else {
                            if (params.data.sim_tracking_state == 1 || params.data.sim_tracking_state == 2 || params.data.sim_tracking_state == 14) {
                                return "Not Registered";
                            }
                            if (params.data.sim_tracking_state == 3 || params.data.sim_tracking_state == 18) {
                                return "Approved";
                            }
                            if (params.data.sim_tracking_state == 4 || params.data.sim_tracking_state == 7 || params.data.sim_tracking_state == 12 ||
                                params.data.sim_tracking_state == 15 || params.data.sim_tracking_state == 16 ||
                                params.data.sim_tracking_state == 17 || params.data.sim_tracking_state == 19 ||
                                params.data.sim_tracking_state == 20 || params.data.sim_tracking_state == 21 ||
                                params.data.sim_tracking_state == 23 || params.data.sim_tracking_state == 24 ||
                                params.data.sim_tracking_state == 25 || params.data.sim_tracking_state == 26) {
                                return "Consent Approved";
                            }
                            if (params.data.sim_tracking_state == 5 || params.data.sim_tracking_state == 6 || params.data.sim_tracking_state == 11 || params.data.sim_tracking_state == 22) {
                                return "Consent Pending";
                            }
                            if (params.data.sim_tracking_state == 8 || params.data.sim_tracking_state == 10) {
                                return "Consent Declined";
                            }
                            if (params.data.sim_tracking_state == 9 || params.data.sim_tracking_state == 18) {
                                return "Approved";
                            }
                            if (params.data.sim_tracking_state == 13) {
                                return "Error";
                            }
                            if (params.data.sim_tracking_state == 14) {
                                return "Not Registered";
                            }
                        }
                    }
                    catch (e) {
                        // console.log(e)
                    }
                },
            },
            {
                headerName: "Expected ETA (Nestlé)",
                field: "expected_eta",
                // headerComponent: headerComponent,
                valueGetter: function (params) {
                    if (params.data.expected_eta != undefined && params.data.expected_eta != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.expected_eta)
                    }
                },
                comparator: (date1, date2) => {
                    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Revised ETA (Enmovil)",
                field: "revised_trip_end",
                // headerComponent: headerComponent,
                valueGetter: function (params) {
                    if (params.data.revised_trip_end != undefined && params.data.revised_trip_end != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
                    }
                },
                cellStyle: function (params) {
                    let revisedDateOnlyMoment = moment(params.data.revised_trip_end);
                    let expectedDateOnlyMoment = moment(params.data.expected_trip_end);
                    try {
                        let hourDifference = 0;
                        if (params.data.revised_trip_end && params.data.expected_trip_end) {
                            let revisedDateOnlyMoment = moment(params.data.revised_trip_end);
                            let expectedDateOnlyMoment = moment(params.data.expected_trip_end);
                            hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours');
                        } else {
                        }
                        if (hourDifference >= 1) {
                            return { backgroundColor: "#ff90a3" };
                        }
                        if (hourDifference <= -1) {
                            return { backgroundColor: "#00dea7" };
                        }
                        else {
                            return ''
                        }
                    } catch (error) {
                    }
                },
                comparator: (date1, date2) => {
                    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Tracking Mode",
                field: "tracking_mode"
            },
            {
                headerName: "Invoice Date",
                field: "invoice_time",
                width: 128,
                valueGetter: function (params) {
                    if (params.data.invoice_time != undefined && params.data.invoice_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.invoice_time)
                    }
                },
                comparator: (date1, date2) => {
                    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Created Date",
                field: "created_date",
                valueGetter: function (params) {
                    if (params.data.created_date != undefined && params.data.created_date != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.created_date)
                    }
                },
                comparator: (date1, date2) => {
                    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Driver Name",
                field: "driver_name",
                width: 128,
            },
            {
                headerName: "Driver Phone No.",
                field: "driver_mobile_no",
                width: 128,
                cellStyle: function (params) {
                    if (params.data.driver_mobile_no != undefined && params.data.driver_mobile_no == 'Invalid Mobile No.') {
                        return { backgroundColor: "#ff90a3" }
                    }
                }
            },
            {
                headerName: "Customer Name",
                field: "consignee_name"
            },
            {
                headerName: "Customer Address",
                field: "consignee_address"
            },
            {
                headerName: "Customer City",
                field: "consignee_city"
            },
            {
                headerName: "Customer State",
                field: "consignee_state"
            },
            {
                headerName: "Customer Zone",
                field: "consignee_zone",
            },
            {
                headerName: "Vehicle Type",
                field: "truck_type",
                width: 128,
            },
            {
                headerName: "Plant Code",
                field: "consigner_code",
                width: 120
            },
            {
                headerName: "Plant Name",
                field: "consigner_name",
                width: 130,
                valueGetter: function (params) {
                    if (params.data.consigner_name != undefined && params.data.consigner_name != '') {
                        return params.data.consigner_name
                    }
                }
            },
            {
                headerName: "Plant Zone",
                field: "consigner_zone"
            },
            {
                headerName: "Gate In Time",
                field: "gate_in_time",
                width: 130,
                valueGetter: function (params) {
                    if (params.data.gate_in_time != undefined && params.data.gate_in_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.gate_in_time)
                    }
                },
                comparator: (date1, date2) => {
                    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Gate Out Time",
                field: "gate_out_time",
                width: 144,
                valueGetter: function (params) {
                    if (params.data.gate_out_time != undefined && params.data.gate_out_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time)
                    }
                },
                comparator: (date1, date2) => {
                    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 158,
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name"
            },
            {
                headerName: "Last Packet Time",
                field: "last_packet_time",
                valueGetter: function (params) {
                    if (params.data.last_packet_time != undefined && params.data.last_packet_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.last_packet_time)
                    }
                }
            },
            {
                headerName: "Customer Distance from Plant",
                field: "dealer_distance_from_plant"
            },
            {
                headerName: "Comment",
                field: "comment_model",
                filter: false,
                width: 107,
                cellRenderer: (param) => {
                    return (
                        <button class="btn btn-warning custom-btn f12 label label-success">Comment</button>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Force Close",
                field: "force_close",
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: ForceClose,
                                params: {
                                    onShowForceCloseModal: onShowForceCloseModal
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Packet Count",
                field: "packet_count",
                width: 144,
                hide: true
            },
            {
                headerName: "Gate In Flag",
                field: "gate_in_flag",
                width: 144,
                hide: true
            },
            {
                headerName: "Gate Out Flag",
                field: "gate_out_flag",
                width: 144,
                hide: true
            },
        ]
    }, []);

    useEffect(() => {
        loadData()
    }, [])

    const submitHandler = (e) => {
        loadData(true)
    }

    const loadData = async (date = false) => {
        let params = {}
        if (date == true) {
            if (startDate == undefined || endDate == undefined || startDate == "" || endDate == "") {
                setShow(true)
                setTitle("Please priovide a valid date")
                setType("danger")
                return
            }
            params["sdate"] = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
            params["edate"] = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
        }
        else {
            setStartDate('')
            setEndDate('')
        }
        setOverlay("show-m")
        setLoadShow("show-m")
        if (user.role[0] == "DEALER")
            params["user_code"] = user.dealer_code ?? "EMPTY"
        else if (user.role[0] == "PLANT") {
            params["plant_codes"] = user.plant_codes ?? "EMPTY"
        }
        await redirectURL.post("consignments/currentTimePastETA", params)
            .then(resp => {
                if (resp.data.status == "success") {
                    let data = JSON.parse(resp.data.apiData)
                    let all_data = parseJSONSafely(data, "all_data")
                    let transit_delay = new Set(parseJSONSafely(data, "transit_delay"))
                    let hot_loads = new Set(parseJSONSafely(data, "hot_loads"))
                    let deviated_routes = new Set(parseJSONSafely(data, "deviated_routes"))
                    setRowData(all_data)
                    setAllData(all_data)
                    setTranistDelay(all_data.filter((item) => transit_delay.has(item._id)))
                    setHotLoads(all_data.filter((item) => hot_loads.has(item._id)))
                    setDeviatedRoutes(all_data.filter((item) => deviated_routes.has(item._id)))
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
            })
            .catch(err => {
                console.log(err)
                setOverlay("show-n")
                setLoadShow("show-n")
            })
    }

    const saveGrid = async (e) => {
        let coloumnState = columnApi.current.api.getColumnState()
        let temp = await saveGridLayout(user.email, "force_closure", coloumnState)
        gridColumnState.current = coloumnState
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = []
        let temp = await saveGridLayout(user.email, "force_closure", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully reset")
            setType("success")
            columnApi.current.api.resetColumnState()
        }
        else {
            setShow(true)
            setTitle("Failed to reset grid")
            setType("danger")
        }
    }


    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setRownode([])
    }

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };

    const onShowForceCloseModal = (e) => {
        setForcecloseModal(true)
        setRownode(e)
    }

    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
    }

    const onClickHideAll = () => {
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setOverlay("show-n")
        setLoadShow("show-n")
    }

    const onClickShowRouteLegs = (rownode) => {
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        var gateouttime = moment.parseZone(e.gate_in_time).format('YYYY-MM-DD HH:mm:ss');
        var edate = '';
        var end_date;
        if (e.status == 1) {
            gateouttime = moment.parseZone(e.gate_in_time).format('YYYY-MM-DD HH:mm:ss')
        }
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = end_date
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = edate = moment.parseZone(e.recent_dealer_reported).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 5) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = moment.parseZone(e.tvp_gate_in).format('YYYY-MM-DD HH:mm:ss')
            }
            else if (e.left_dealer_marked) {
                // end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                end_date = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
                edate = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = moment.parseZone(e.force_closure_time).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 9) {
            end_date = moment.parseZone(e.trip_closure_time).format('YYYY-MM-DD HH:mm:ss')
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = moment.parseZone(end_date).format('YYYY-MM-DD HH:mm:ss')
        }
        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            //console.log("Defining end_date ", end_date);
        }
        if (gateouttime == "Invalid date" && e.gate_out_time != undefined && e.gate_out_time != "") {
            gateouttime = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: gateouttime,
            seconddate: end_date,
            screen: "consignment",
            display_elis_base_route: 1,
            user_email: user.email
        }
        if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                // this.setState({
                //     loadshow: 'show-m'
                // });
                if (response?.data?.status == "failure") {
                    setShow(true)
                    setTitle((e.last_packet_time != undefined && e.last_packet_time != "") ? "Map becomes accessible once the vehicle has been gated in" : "No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                    return
                }
                else if (!(response?.data !== null && typeof response?.data === 'object')) {
                    setShow(true)
                    setTitle((e.last_packet_time != undefined && e.last_packet_time != "") ? "Map becomes accessible once the vehicle has been gated in" : "No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
                try {
                    if (records.coords.length == 0) {
                        setShow(true)
                        setTitle((e.last_packet_time != undefined && e.last_packet_time != "") ? "Map becomes accessible once the vehicle has been gated in" : "No GPS data available ")
                        setType("danger")
                        setOverlay("show-n")
                        setLoadShow("show-n")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = end_date
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = end_date
                                }
                            }
                            // if (e.deviation_flag == 1) {
                            let consignee_city;
                            consignee_city = e.consignee_city
                            var params = {
                                "base_route_id": e.base_route_id,
                                "consigner_code": e.consigner_code,
                                "consignee_city": consignee_city
                            }
                            // redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                            //     params).then((resp) => {
                            var baseRouteCoords = eval(records.base_route);
                            setOpenMap({
                                overly: "show-m",
                                sliderRouteTranslate: "slider-translate-60p",
                                mapinfo: records,
                                dealer: e.consignee_code,
                                consignment_code: "FO Number : " + e.fo_number,
                                maptruckno: e.truck_no,
                                routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                loadshow: 'show-n',
                                sidebarSubHeader: "Consignment Information",
                                rownode: e,
                                leg_no: 0,
                                tolls: records.tolls,
                                baseRouteCoords: baseRouteCoords
                            })
                            setLoadShow("show-n")
                            var params =
                            {
                                consignee_code: e.consignee_code,
                                dept_code: e.dept_code
                            }
                            redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                var records1 = response.data.records;
                                let parkingGeodata = []
                                if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                var geofence_coords = []
                                if (records1.length) {
                                    geofence_coords = records1[0].geofence_coordinates;
                                }
                                setLoadShow("show-n")
                            })
                        }
                    }
                }
                catch (e) {
                }

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const onGridReady = useCallback(async (params) => {
        await fetchGridLayout(user.email, "force_closure")
            .then(async res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    gridColumnState.current = res.data.data[0].columnState
                    setTimeout(async () => {
                        await params.api.applyColumnState({
                            state: res.data.data[0].columnState,
                            applyOrder: true,
                        })
                    }, 1500);
                }
            })
            .catch(err => console.log(err))
    }, []);


    const CounterClick = (counter) => {
        switch (counter) {
            case "transit_delay":
                setRowData(tranistDelay)
                setHeader("Transit Delay")
                break;
            case "deviated_route":
                setRowData(deviatedRoutes)
                setHeader("Deviated Route")
                break;
            case "consignments":
                setRowData(allData)
                setHeader("Total FO Deliveries")
                break;
            case "hot_loads":
                setRowData(hotLoads)
                setHeader("Hot Loads")
                break;
            default:
                setRowData(allData)
                setHeader("Total FO Deliveries")
                break;
        }
    }

    const onCellClicked = (params) => {
        if (params.colDef.field == "comment_model") {
            setCommentModal(true)
            setRownode(params.data)
        }
        else if (params.colDef.field == "comment_logs") {
            let nogpscols = [
                {
                    headerName: "FO Number",
                    field: "fo_number",
                },
                {
                    headerName: "Vehicle No.",
                    field: "truck_no",
                },
                {
                    headerName: "Customer Code",
                    field: "consignee_code",
                },
                {
                    headerName: "Customer Name",
                    field: "consignee_name",
                },
                {
                    headerName: "Comment",
                    field: "comment",
                },
                {
                    headerName: "Commented By",
                    field: "email",
                },
                {
                    headerName: "Commented Date",
                    field: "created_on",
                    valueGetter: function (params) {
                        if (params.data.created_on != undefined && params.data.created_on != '') {
                            return getHyphenDDMMMYYYYHHMM(params.data.created_on)
                        }
                    },
                },
            ]
            params.node.setExpanded(!params.node.expanded)
            setdetailCellRendererParams({
                detailGridOptions: {
                    columnDefs: nogpscols,
                    defaultColDef: {
                        flex: 1,
                    },
                },
                getDetailRowData: (params) => {
                    redirectURL.post('/consignments/showCommentLegs', {
                        consignment_code: params.data.consignment_code
                    })
                        .then(async (response) => {
                            params.successCallback(response.data.comments ?? []);

                        });
                },
            })
        }
    }

    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={type}
                title={title}
                onConfirm={() => { setShow(false); setTitle('') }}>
            </SweetAlert>
            {
                commentModal &&
                <CommentModal setShow={setShow} setTitle={setTitle} setType={setType} user={user} commentModal={commentModal}
                    consignment={rownode} setCommentModal={setCommentModal} loadData={loadData} setRownode={setRownode} />
            }
            <Modal
                onHide={closeForceCloseModal}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <ModelForceClose rownode={rownode} setShow={setShow} setTitle={setTitle} setType={setType} closeForceCloseModal={closeForceCloseModal} changeReloadPage={loadData} user={user} />
                </Modal.Body>
            </Modal>
            <h5 className="mb-15p fbold f20">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i><span style={{ fontWeight: "600" }}>Force Closure</span>
                <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="tooltip-example">This page lists all active consignments that have exceeded their Expected ETA (Nestlé).</Tooltip>}>
                    <img src={Info} width="16px" style={{ position: "absolute" }} />
                </OverlayTrigger>
            </h5>
            <div className="row">
                <div className="row col-xl-12 col-lg-12">
                    <div className="col-xl-3 col-lg-3 form-group">
                        <label>Invoice From Date</label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            className="form-control"
                            autoComplete="off"
                            placeholderText="From Invoice date"
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div className="col-xl-3 col-lg-3 form-group">
                        <label>Invoice To Date</label>
                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            className="form-control"
                            autoComplete="off"
                            placeholderText="To Invoice date"
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div className={"col-xl-3 col-lg-3 form-group float-left"}>
                        <label></label><br />
                        <button type="button" onClick={submitHandler} className="btn btn-success mt-9p">Submit</button>
                    </div>
                </div>
                <div className="col-xl-12 col-lg-12 col-sm-12 beffect">
                    <div className="card" style={{ height: "148px" }}>
                        <div className="card-body row" style={{ padding: "14px", overflow: "hidden" }}>
                            <div className="col-md-3 cpointer addition-col-right" onClick={() => CounterClick("consignments")}>
                                <h4 className="greenfont f35">
                                    <span className="counter">
                                        <CountUp end={allData.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Total FO Deliveries
                                </span>
                            </div>
                            <div className="col-md-3 cpointer addition-col-right" onClick={() => CounterClick("transit_delay")}>
                                <h4 className="f35" style={{ color: "#ff5370" }}>
                                    <span className="counter">
                                        <CountUp end={tranistDelay.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Transit Delay
                                </span>
                            </div>
                            <div className="col-md-3 cpointer addition-col-right" onClick={() => CounterClick("hot_loads")}>
                                <h4 className="f35" style={{ color: "#f4e0af" }}>
                                    <span className="counter">
                                        <CountUp end={hotLoads.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Hot Loads
                                </span>
                            </div>
                            <div className="col-md-3 cpointer addition-col-right" onClick={() => CounterClick("deviated_route")}>
                                <h4 className="f35 purple">
                                    <span className="counter">
                                        <CountUp end={deviatedRoutes.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Deviated Routes
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-12 col-lg-12 col-sm-12">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12">
                            <div className="card">
                                <div className="card-header main-page-display">
                                    <h5>
                                        <i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>{`${header}`}</span>
                                    </h5>
                                    <div>
                                        <button type="button" title="Reset Grid Layout" name="resetgrid" className="btn btn-info float-right action_btn main-page-gridbutton" onClick={resetGrid}> <i className="fa fa-reply"></i> </button>
                                        <button type="button" title="Save Grid Layout" name="savegrid" className="btn btn-success float-right action_btn main-page-gridbutton" onClick={saveGrid}> <i className="fa fa-save"></i> </button>
                                        <BulkForceClose setOverlay={setOverlay} setType={setType} setTitle={setTitle} setShow={setShow}
                                            loadConsignmentsData={loadData} user={user} />
                                    </div>
                                </div>
                                <div className="card-body" style={{ padding: "14px", overflow: "hidden" }}>
                                    <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                        <AgGridReact
                                            ref={columnApi}
                                            columnDefs={columnDefs3}
                                            rowData={rowData}
                                            defaultColDef={defaultColDef}
                                            pagination={true}
                                            paginationPageSize={50}
                                            onGridReady={onGridReady}
                                            enableRangeSelection={true}
                                            enableCellContextMenu={true}
                                            masterDetail={true}
                                            detailCellRendererParams={detailCellRendererParams}
                                            onCellClicked={onCellClicked}
                                            sideBar={{
                                                toolPanels: [
                                                    {
                                                        id: "columns",
                                                        labelDefault: "Columns",
                                                        labelKey: "columns",
                                                        iconKey: "columns",
                                                        toolPanel: "agColumnsToolPanel",
                                                        toolPanelParams: {
                                                            suppressPivotMode: true,
                                                            suppressRowGroups: true,
                                                            suppressValues: true,
                                                        }
                                                    },
                                                    {
                                                        id: "filters",
                                                        labelDefault: "Filters",
                                                        labelKey: "filters",
                                                        iconKey: "filter",
                                                        toolPanel: "agFiltersToolPanel"
                                                    }
                                                ]
                                            }}
                                            statusBar={{
                                                statusPanels: [
                                                    {
                                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                                        align: "left"
                                                    },
                                                    {
                                                        statusPanel: "agTotalRowCountComponent",
                                                        align: "center"
                                                    },
                                                    { statusPanel: "agFilteredRowCountComponent" },
                                                    { statusPanel: "agSelectedRowCountComponent" },
                                                    { statusPanel: "agAggregationComponent" }
                                                ]
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openMap.sliderRouteTranslate != '' ?
                    <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                        <div className="slide-r-title">
                            <h4>
                                {(openMap.consignment_code)}
                                <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeMapModal} >X</span>
                            </h4>
                        </div>
                        <div className="slide-r-body" style={{ position: "relative" }}>
                            <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                                <DrawMap
                                    rownode={openMap.rownode}
                                    mapFor={"consignment"}
                                    tolls={openMap.tolls}
                                    googleroutes={openMap.googelRoutes}
                                    truckno={openMap.maptruckno}
                                    dealer={openMap.dealer}
                                    mapinfo={openMap.mapinfo}
                                    deptcode={openMap.deptcode}
                                    defTransitCoords={openMap.defTransitCoords}
                                    baseRouteCoords={openMap.baseRouteCoords}
                                    geofence_coordinates={openMap.geofence_coordinates}
                                    parking_coordinates={openMap.parking_coordinates}
                                />
                                <div className="col-xl-12 col-lg-12 n-p-0">
                                    <div className="crm-numbers pb-0">
                                        <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                        <div className="col-xl-12 col-lg-12 row">
                                            <div className="col route-block">
                                                <label className="sidebar-label">Vehicle No.</label>
                                                <div>{openMap.routeTruck.truck_no}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">Start Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">End Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                            </div>

                                            <div className="col route-block">
                                                <label className="sidebar-label">GPS Distance</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""
            }
            <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                onClick={onClickHideAll}
            ></div>
            <div className={"dataLoadpage " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </div>
    )
}
export default ETAPastConsignments


function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

function parseJSONSafely(data, key) {
    try {
        return JSON.parse(data[key]);
    } catch (error) {
        console.error(`Error parsing JSON for key "${key}":`, error);
        return []; // Return a default value, e.g., null or an empty object
    }
}